import { useQuery } from 'react-query';

import { axios } from 'configurations/axios';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { useSessionStore } from 'session/useSessionStore';
import { IDataSourceLayer } from '../models/interfaces/IDataSourceLayer';

export const useGetAllDataSourceLayers = () => {
    const { host, jwt } = useSessionStore(state => ({
        host: state.tenantConfiguration?.endpoints.webApiHost,
        jwt: state.jwtToken,
    }));

    return useQuery<IDataSourceLayer[]>(
        ['GetAllDataSourceLayers'],
        async () => {
            const response = await axios.get<IResponseAPI<IDataSourceLayer[]>>(
                `${host}/DataSourceLayer/GetAll`,
                {
                    headers: {
                        Authorization: 'Bearer ' + jwt,
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data.Result;
        },
        {
            enabled: !!host,
        }
    );
};
